import styled from 'styled-components';
import { VIEWPORTS, SHARED_STYLES } from '@constants';

// Styles for components that are used by many slides

// To-do: add support for other browsers

export const SlideIcon = styled.img`
    background: transparent;
    width: 40px;
    height: 33px;
    margin-right: 20px;
    padding: 8px;
    color: #002939;
`;

export const Line = styled.hr`
    color: #E3E3E3;
    width: 100%;
    height: 1px;
`;

// To-do: make this a function that does not display the scrollbar if the client is viewing
export const ScrollBarStyle = ` 
    ::-webkit-scrollbar {
        width: 5px;
    }
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    ::-webkit-scrollbar-thumb {
        background: #888;
    }
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;


export const SlideList = styled.ul`
    list-style-type: none;
    position: relative;
    padding: 0;
    margin: 1rem 0 4rem 0;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    @media (min-width: 770px) {
        width: 770px;
    }
`;

export const RemoveSlideFromList = styled.span`
    position: absolute; 
    //border: 1px solid grey; 
    border-radius: 5px;
    top: 0;
    right: 0; 
    padding: 0 5px;
`;

function getSlideTileBackground(props) {
    const { selected, disabled } = props;

    if (selected) {
        return '#E5EBF0';
    } else if (disabled) {
        return 'lightgrey';
    }

    return '#FFF';
}

export const SlideListItem = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    background: ${props => getSlideTileBackground(props)};
    font-family: ${props => props.theme.sansSerif};
    font-size: ${props => props.theme.smallFont};
    font-weight: ${props => props.selected ? '600' : '500'};
    width: 100px;
    height: 72px;
    border: 1px solid #012939;
    border-radius: 8px;
    margin-top: 8px;
    margin-right: 10px;
    padding: 12px 8px;
    text-align: center;
    color: ${props => props.selected ? '#091E28' : '#012939'};
    &.slide-menu-item {
        border: 1px solid grey;
    }
    &:hover, &:active {
        cursor: pointer;
        border: 2px solid grey;
        color: #0056B3;
    }
`;

export const Slide = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border: 2px solid black;
    height: 580px;
    width: 100%;
    max-width: ${SHARED_STYLES.maxSlideWidth};
    position: relative;
    font-family: ${props => props.theme.sansSerif};
    overflow-x: hidden;
    overflow-y: auto;
    @media (min-width: ${props => props.theme.maxSlideWidth}) {
        width: ${props => props.theme.maxSlideWidth};
        margin: 0 auto;
    } 
    ${props => props.viewport === VIEWPORTS.mobile && `
        @media screen and (orientation: landscape) {
            width: 100%;
        }
    `};
    ::-webkit-scrollbar {
        width: 5px;
    }
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    ::-webkit-scrollbar-thumb {
        background: #888;
    }
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    ${({ pdfStyleActive }) => pdfStyleActive && `
        box-sizing: border-box;
        border: 1px solid black;
        width: 100%;
        padding: 0px;
        position: relative;
        overflow-y: auto;
  `}
`;

export const SlideBodyStyle = styled.div`
    padding: 0 22px;
    flex: 1 0 auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    z-index: ${props => props.clientViewing ? '-2' : '0'};
    overflow-y: auto;
    overflow-x: hidden;
    height: ${props => props.desktop ? '85%' : '80%'};
    ${props => !props.desktop && props.name !== 'Introduction' && `
        padding-bottom: 25px;
    `}
    position: relative;
    top: 0;
    font-family: Noto Sans, sans-serif;
    ${ScrollBarStyle}
`;

export const SlideSection = styled.div`
    width: 100%;
    position: relative;
    ${props => props.height && `height: ${props.height}`};
    ${({flex}) => flex ? 'display: flex': null};
    label.section {
        display: ${({visible}) => visible? 'inline' : 'none'};
        cursor: pointer;
        position: absolute;
        z-index: 15;
        background: white;
        border-radius: 50%;
        border: 2px solid black;
        padding: 5px 10px;
        font-weight: bold;
        left: -6px;
        top: -20px;
    }
    border: ${({ selected, visible }) => selected && visible ? '2px solid red' : '1px transparent'}
`;

export const SliderContainer = styled.div`
    display: flex;
    flex-direction: ${props => props.desktop ? 'row' : 'column'};
    justify-content:  ${props => props.desktop ? 'center' : 'space-between'};
    align-items: center;
    width: 100%;
    ${props => props.mobile && 'height: 30vh'};
    margin-bottom: ${props => props.desktop && props.marginBottom};
`;

SliderContainer.defaultProps = {
    marginBottom: '1.8rem'
};

export const TermsContainer = styled.div`
    display: flex;
    flex-direction: column; 
    align-items: center;
    width: ${props => props.desktop ? '50%' : '100%'};
    ${props => !props.desktop && 'margin-bottom: 20px'};
`;

export const TermsDropdown = styled.select`
    width: 100%;
    z-index: ${props => props.clientViewing ? '-1' : '1'};
    font-family: ${props => props.theme.sansSerif};
    background: #F9F9F9;
    border: 1px solid #012939;
    box-sizing: border-box;
    box-shadow: 0px 4px 8px rgba(26, 26, 26, 0.12);
    border-radius: 4px;
    font-size: 20px;
    font-weight: 600;
    padding: 10px;
    height: 48px;
    option {
        display: flex;
        justify-content: space-between;
    }
`;

export const TermLabel = styled.label`
    font-size: 15px;
    font-weight: 600;
    display: flex;
    align-items: center;
    text-align: center;
    color: #323232;
    margin-bottom: 10px;
`;

export const TermExplanation = styled.div`
    text-align: center;
    height: 100%;
    margin-left: 10px;
    margin-top: ${props => props.marginTop || '0'};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: ${props => props.desktop ? '50%' : '100%'};
    h2 {
        background-color: ${({background}) => background ? background : '#012939'};
        font-size: 24px;
        padding: 10px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        color: ${props => props.color ? props.color : '#fff'};
        width: 100%;
        border-radius: 4px;
        height: ${props => props.height || '48px'};
    }
`;

export const Header = styled.h4`
    font-weight: 700;
    font-size: ${props => props.fontSize};
    margin: 4px 0;
`;

Header.defaultProps = {
    fontSize: '17px'
};

export const SectionHeader = styled(Header)`
    width: ${({ width }) => width ? width : '100%'};
    ${props => props.border && 'border-bottom: 1px solid rgba(0,0,0,.125)'};
    font-size: ${props => props.fontSize};
    position: static;
    left: calc(50% - 348px/2);
    margin: ${({ margin }) => margin ? margin : '16px 0' };
    padding-bottom: 5px;
`;

SectionHeader.defaultProps = {
    border: true
};

export const HeaderWithBalance = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    >span {
        display: inherit;
        justify-content: space-between;
        border: 2px solid grey;
        padding: 15px;
        margin: 0 25px;
    }
    h3 {
        color: #222222;
        font-size: 16px;
        font-weight: 600;
    }
    h2 {
        font-size: 24px;
    }
    h2:nth-of-type(2) {
        padding-left: 25px;
    }
`;

export const Step = styled.div`
    width: 100%;
    border: ${props =>`1px solid ${props.selected ? '#012939' : '#7F9DB3'}`};
    background: ${props => props.selected ? '#E0F2FF' : '#F9F9F9'};
    border-radius: 4px;
    display: flex;
    box-shadow: 0px 4px 8px rgba(26, 26, 26, 0.12);
    padding: 10px;
    cursor: pointer;
    h4 {
        font-size: ${props => props.theme.mediumFont};
    }
`;

const UnstyledList = styled.ul`
    list-style-type: none;
    padding-inline-start: 0;
    margin-block-end: 0;
    margin-block-start: 0;
`;

export const GridListStyle = styled(UnstyledList)`
    width: 100%;
    display: grid;
    margin: 5px 0 10px 0;
    grid-template-columns: ${props => props.desktop ? '1fr 1fr' : '1fr'};
    grid-template-rows: ${props => props.desktop ? '1fr 1fr' : '1fr'};
    column-gap: 15px;
    row-gap: 15px;
`;

export const SplitGridList = styled(GridListStyle)`
    grid-template-columns: ${props => props.desktop ? '1fr 1fr' : '1fr' };
    grid-template-rows: 1fr auto;
    margin: ${props => props.desktop ? '0' : '0 0 15px 0'};
`;

export const ChecklistContainer = styled.div`
    display: flex;
    flex-direction: ${props => props.desktop ? 'row' : 'column'};
    justify-content: space-evenly;
    align-items: flex-start;
    height: ${props => props.desktop ? '70%' : '100%'};
`;

export const ChecklistDivider = styled.div`
    height: 100%;
    width: 1px;
    background-color: ${props => props.theme.lightGrey};
    margin: 0 20px;
`;

export const Checklist = styled(UnstyledList)`
    display: grid;
    width: ${props => props.desktop ? '50%' : '100%'};
    height: 50%;
    grid-template-rows: ${props => props.desktop ? '1fr 1fr 1fr' : '1fr'};
    grid-template-columns: 1fr;
`;

function getChecklistStyle(props) {
    const { selected, covered } = props;

    if (selected) {
        return (`
            background: transparent;
            color: #012939;
        `);
    } else if (!selected && covered) {
        return (`
            background: rgba(127, 157, 179, 0.5);
            color: #fff;
        `);
    } else {
       return (`
            border: 1px solid rgba(127, 157, 179, 0.5);
            background: transparent;
            color: #fff;
       `);
    }
};

export const ChecklistItemStyle = styled.li`
    display: flex;
    align-items: flex-start;
    font-size: ${props => props.theme.smallFont};
    color: #323232;
    ${props => props.desktop && 'height: 100%;'}
    width: 100%;
    background: ${props => props.selected ? props.theme.secondaryLightBlue : 'transparent' };
    border-radius: 5px;
    padding: 10px 8px 0 5px;
    margin: 0 0 8px 0;
    >label {
        width: 100%;
        padding-bottom: 5px;
    }
    svg {
        margin: 0 10px;
        width: 20px !important;
        height: 20px;
        border-radius: 50%;
       ${props => getChecklistStyle(props)};
    }
`;

export const ChartWrapper = styled.div`
    display: flex;
    flex-direction: column;
    >div {
        display: flex;
        align-items: center;
    }
    #legend {
        list-style-type: none;
        display: flex;
        flex-direction: column;
        padding-inline-start: 0px;
        margin-left: 15px;
    }
`;

export const LegendKey = styled.li`
    margin-left: 15px;
    padding: 10px 0;
    font-size: 13px;
    font-weight: 600;
    line-height: 16.9px;
    >div {
        width: 100%;
        >span:first-child {
            font-size: 14px;
            font-weight: 700;
            border: 2px solid ${props => props.color};
            border-radius: 5px;
            padding: 5px 5px 5px 7px;
            margin: 7px;
            width: 50%;
        }
    }
    .color {
        color: ${props => props.color};
        background-color: ${props => props.color};
        margin: 0 7px 0 0;
        display: inline-block; 
        width: .7em;
        height: .7em;
    }
`;

export const GlobalTableStyle = styled.table`
    font-family: inherit;
    font-style: normal;
    table-layout: fixed;  
    width: 100%;
    th {
        color: #323232;
        background-color: #fff;
        border: 1px solid #1A1A1A;
    }
`;

export const MobileTableStyle = styled(GlobalTableStyle)`
    tbody {
        border-collapse: separate;
        border-spacing: 2px;
    }
    tbody {
        background: transparent;
    }
    tr {
        background: transparent;
    }
    td:nth-of-type(1) {
        color: #323232;
        background-color: #fff;
        border: 1px solid #1A1A1A;
        text-align: left;
        font-weight: 500;
    },
    td:nth-of-type(2) {
        background-color: ${props => props.background || props.theme.primaryLightBlue};
        font-weight: 700;
        text-align: right;
        margin: 1px 0;
    }
`;

export const TermOptionsTableStyle = styled(GlobalTableStyle)`
    border-collapse: separate; 
    border-spacing: 10px 2px;
    margin-bottom: 20px;   
    th, td {
        text-align: center;
    }
    th {
        border: 1px solid ${props => props.theme.primaryDarkBlue}
    }
    td {
        background: ${props => props.cellColor};
    }
`;

export const SummaryTableStyle = styled(GlobalTableStyle)`
    ${props => !props.desktop && 'display: block'};
    overflow-x: auto;
    ${ScrollBarStyle};
    whitespace: nowrap;
    th, td {
        text-align: left;
        width: 100%;
        min-width: 100px;
    }
    th, td:nth-of-type(1) {
        font-weight: 600;
        border: 1px solid ${props => props.theme.primaryDarkBlue};
        background: #fff;
    }
    th:nth-child(1) {
        background: transparent;
        border: none;
    }
    td {
        font-weight: bold;
    }
    td:nth-of-type(2) {
        background: #E5E5E5;
    }
    td:nth-of-type(3) {
        background: ${props => props.theme.secondaryLightBlue};
    }
    td:nth-of-type(4) {
        background: #B8E1FF;
    }
    margin-bottom: 15px;
`;

export const TableStyleTwo = styled.table`
    table-layout: fixed;
    tr {
        height: ${({ isRebuttal }) => isRebuttal ? '46px' : '26px'};
        line-height: 18.2px;
    }
    td:nth-child(1) {
        text-align: left;
        color: #323232;
        background-color: #fff;
        border: 1px solid #1A1A1A;
    }
    td:nth-child(2) {
        text-align: right;
        background: #E0F2FF;
        font-weight: 700;
    }
`;

export const TableStyleThree = styled(GlobalTableStyle)`
    table-layout: fixed;
    tr {
        font-weight: bold;
        height: ${({ rowHeight }) => rowHeight ? rowHeight : '26px'};
        th {
            text-align: ${({textAlign}) => textAlign ? textAlign : 'center'};
        }
        td {
            background: ${props => props.background || props.theme.secondaryLightBlue};
        }
    }
`;

const scrollbarWidth = '5px';
const cellWidth = '99px';
const exceptionWidth = (parseInt(cellWidth) - parseInt(scrollbarWidth)) + 1;

export const CreditorTableStyle = styled(GlobalTableStyle)`
    max-height: 187px;
    margin: 10px 0;
    z-index: ${props => props.clientViewing ? '-2' : '0'};
    th, td {
        width: ${props => props.desktop ? cellWidth : '100%'};
    }
    td {
        border: 1.5px solid #fff;
        color: #000000;
    }
    tbody { 
        display: block;
        overflow-y: auto;
        max-height: 175px;
        border-collapse: collapse;
        width: 100%;
        position: relative;
        td:last-child {
            width: ${props => props.desktop ? exceptionWidth + 'px' : '100%'};
        }
        ${ScrollBarStyle}
        ::-webkit-scrollbar {
            width: 5px;
        }
    }
    tr {
        width: 100%;
        display: inline-table;
        table-layout: fixed;
    }
    td.text-right, th.text-right {
        text-align: right;
    }
    tfoot, thead {
        position: sticky;
    }
    #totals {
        td {
            background: #B0DEFF;
            border: none;
            font-weight: 700;
        }
        td:nth-of-type(1) {
            background-color: #012939;
            color: #fff;
            font-weight: bold;
            text-align: right;
            width: ${props => props.desktop ? '199px' : '100%'};
        }
    }
    tr:nth-child(even) td {
        background: #F9F9F9;
    }
    tr:nth-child(odd) td {
        background: #E6E6E6;
    }
`;

export const DisclaimerStyle = styled.div`
    position: ${props => props.intro ? 'absolute': 'relative'};
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0%;
    padding: 5px;
    background: ${props => props.intro ? 'transparent' : 'rgba(0, 0, 0, 0.04)'};
`;

export const DisclaimerText = styled.div`
    font-family: ${props => props.theme.sansSerif};
    font-style: normal;
    font-weight: 500;
    font-size: 9px;
    line-height: 12px;
    text-align: center;
    height: 100%;
    z-index: 3;   
    width: ${props => props.width || '95%'};
    color: ${props => props.color || '#969696'};
`;
